import { clearConversationFromStorage } from './conversationStorage';

export const DEVELOPER_ASSISTANT_HOME_NAVIGATION_EVENT =
  'developer-assistant:home-navigation-click';

export const clearDeveloperAssistantConversation = (): void => {
  clearConversationFromStorage();
};

export const requestDeveloperAssistantHomeNavigation = (): boolean => {
  const event = new CustomEvent(DEVELOPER_ASSISTANT_HOME_NAVIGATION_EVENT, {
    cancelable: true,
  });

  const shouldNavigate = window.dispatchEvent(event);

  // If any event listener calls preventDefault, shouldNavigate will be false.
  if (shouldNavigate) {
    clearDeveloperAssistantConversation();
  }

  return shouldNavigate;
};
